/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PendingRegistrationResponseParser = 
/* #__PURE__ */ parsers.object([['id', codecString]]);
export class PendingRegistrationResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PendingRegistrationResponseParser.decode(input).map(res => new PendingRegistrationResponse(res));
    }
    static unsafeDecode(input) {
        return PendingRegistrationResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PendingRegistrationResponseParser.encode(data);
    }
    static schema() {
        return PendingRegistrationResponseParser.schema();
    }
}
